<template>
	<div class="activityBox" :id="'pullrefresh'+idIndex" :typeCode="activityArr[0]['TYPE_CODE']">
		<div class="imgcontainer" v-for="(item,index) in activityItemArr[idIndex]" v-if="index == 0" v-on:click="toDetailInfo(index)">
			<router-link :to="{ name:'activityDetail',params: { infoId: item.INFO_ID},query: { typeCode: item.TYPE_CODE }}" >
				<!-- <img src="../../assets/img/index-activity.png"> -->
				<img v-bind:src="imgSrc+item.PIC_PATH" /> 
				<div class="box-title">
					<div class="activity-title">{{item.TITLE}}</div>
				</div>
			</router-link>
		</div>
		
		<div class="container" v-for="(item,index) in activityItemArr[idIndex]" v-if="index > 0" v-on:click="toDetailInfo(index)">
			<router-link :to="{ name:'activityDetail',params: { infoId: item.INFO_ID},query: { typeCode: item.TYPE_CODE }}">
				<div class="imgContainer">
					<!-- <img src="../../assets/img/index-exchange.png" /> -->
					<img v-bind:src="imgSrc+item.PIC_PATH" /> 
				</div>
				<div class="textContainer">
					<div class="text-title">{{item.TITLE}}</div>
					<div class="text-content">{{item.ABSTRACT}}</div>
				</div>
				<div class="line"></div>
			</router-link>
		</div>
		<!-- <div class="loading" v-show="loadingIndex"><img src="../../assets/img/loading.gif" /><span>{{loadingTxt}}</span></div> -->
	</div>
</template>
<script>
	import Server from '../../server/server.js'
	import $ from 'jquery'
	import Vue from "vue"
	import {commonPicUrl} from '../../common/url.js'
	export default {
	  	name: 'tabList',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,	
		  		activityItemArr:[],
		  		startIndex:[],//4
		  		endIndex:[],//7
		  		pageLength:4,
		  		page:[],//0
		  		loadingIndex:[],   //滚动是否加载数据,初始值为true
		  		timer:null,
		  		loadingTxt:[],//加载数据前数据提示,初始值为加载中
		  		loadingTimer:null,
		  	}
	  	},
	  	props:['activityArr','idIndex','activityAllArr'],
	  	methods:{
	  		//跳转资讯详情
	  		toDetailInfo:function(index){
	  			let sequence = parseInt(index);
	  			localStorage.setItem('activitySequence',sequence);
	  		},
	  		getInfo:function(page,typeCode,index){
	  			let startIndex = page+this.startIndex[index];
	  			let endIndex = page+this.endIndex[index];
	  			Server.listInfo(startIndex,endIndex,typeCode).then((result)=>{
		  			if(result.code == '0'){
		  				console.log(result.msg.infos);
		  				if(result.msg.infos.length>0){
		  					this.activityItemArr[index] = this.activityItemArr[index].concat(result.msg.infos);
		  					if(result.msg.infos.length < this.pageLength){
		  						this.loadingTxt[index] = '没有更多内容了';
		  					}
		  					Vue.set(this.activityItemArr,index,this.activityItemArr[index]);  //手动刷新数据
		  				}else{
		  					let that = this;
		  					that.loadingIndex[index] = !that.loadingIndex[index];		  					
		  				}	
		  			}
		  		})
	  		},
	  		
	  	},
	  	created(){
	  		this.activityItemArr =this._props.activityAllArr;
	  	},
	  	mounted(){
	  		let activityLength = $('.activityBox').length;
	  		for (let i = 0; i < activityLength; i++){
	  			this.startIndex[i]=0;
	  			this.endIndex[i]=3;
	  			this.page[i]=0;
	  			this.loadingIndex[i]=true;
	  			this.loadingTxt[i]='正在加载中...';
	  		}	  
	  		let that = this;
	  		$('.activityBox').scroll(function(){
	  			let id = $(this).attr("id");
	  			let jqueryId = '#'+id;
	  			let scrollIndex = parseInt(id[id.length-1]); //通过获取元素ID来确定是第几个activityBox
	  			if(that._props.idIndex == scrollIndex){
	  				let typeCode = $(this).attr("typeCode");  //获取该activityBox 的栏目号
			        var contentHeight = $(jqueryId).height(),
			            contentScroll = $(jqueryId).scrollTop(),
			            contentScrollHeight = document.getElementById(id).scrollHeight;
			        if(that.loadingIndex[scrollIndex]){
			        	if(contentHeight+contentScroll+0>=contentScrollHeight){
			        		console.log(contentHeight,contentScroll,contentScrollHeight);
			        		clearTimeout(that.timer);
			        		that.timer=setTimeout(function () {
				                that.page[scrollIndex] = that.page[scrollIndex] +that.pageLength;
				            	that.getInfo(that.page[scrollIndex],typeCode,scrollIndex);
				            },500);
				        }
			        }
	  			}		        
		    })		
	  	},
	}
</script>
<style lang="less" scoped>
	.activityBox{
		width:100%;
		height:800px;
		overflow:scroll;
		.imgcontainer{
			width:100%;
			border-radius:10px;
			margin-top:30px;
			position:relative;	
			max-height:340px;
			overflow:hidden;		
			img{
				width:100%;
				max-height:340px;
			}
			.box-title{
				width:100%;
				height:120px;
				border-radius:0 0 10px 10px;
				position:absolute;
				bottom:0;
				padding:15px 20px;
				background-image:linear-gradient(-180deg, rgba(255,255,255,0.00) 4%, #4a4136 97%);
				font-size:28px;
				color:#ffffff;
				letter-spacing:0;
				text-shadow:0 2px 4px rgba(0,0,0,0.50);
				text-align:left;
				.activity-title{
					width:100%;
					height:80px;
					text-overflow:ellipsis;
					overflow: hidden;
			    	display: -webkit-box;
	    			-webkit-line-clamp: 2;
	    			-webkit-box-orient: vertical;
	    			word-break:break-all;
	    			-webkit-box-orient: vertical;
	    			line-height:30px;
				}
			}
		}
		.container{
			width:100%;
			margin-top:30px;
			display:inline-block;
			.imgContainer{
				float:left;
				width:30%;
				img{
					width:100%;
					max-height:200px;
				}
			}
			.textContainer{
				float:right;
				width:70%;
				padding-left:20px;
				text-align:left;
				.text-title{
					font-size:28px;
					color:#333333;
					letter-spacing:0;
					line-height:40px;
					height:40px;
					text-overflow:ellipsis;
					overflow: hidden;
			    	display: -webkit-box;
	    			-webkit-line-clamp: 1;
	    			-webkit-box-orient: vertical;
	    			-webkit-box-orient: vertical;
	    			word-break:break-all;
	    			font-weight:bold;
				}
				.text-content{
					margin-top:5px;
					font-size:24px;
					color:#666666;
					letter-spacing:0.08px;
					line-height:40px;
					
					overflow: hidden;
			    	display: -webkit-box;
	    			-webkit-line-clamp: 3;
	    			-webkit-box-orient: vertical;
	    			word-break:break-all;
	    			-webkit-box-orient: vertical;
				}
			}
			.line{
				margin-top:30px;
				float:left;
				width:100%;
				background:#d8d8d8;
				height:2px;
			}
		}
		.loading{
			width:100%;
			height:40px;
			text-align:center;
			line-height:40px;
			img{
				vertical-align:middle;
				width:40px;
			}
			span{
				padding-left:10px;
				font-size:26px;
				color:#666666;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/activityComponents/tabList.vue